import React, { Component } from 'react';

// Components
import { PageSection } from '../PageSection';
import { DownArrow } from '../generic/DownArrow';

export class AppSummary extends Component {
    render() {
        // TODO: Right now this is just a straight dump of the original raw code. Need to component-ise it and tidy up. Given more time the 3 copies should be done with css
        return (
            <PageSection sectionId="app-summary">
                <img src="./images/generic/bg-icon-heart.png" alt="" style={{ position: 'absolute', top: '300px', left: '80px', zIndex: -1 }} />
                <img src="./images/bg/bg-lower-left-smaller.png" alt="" style={{ position: 'absolute', top: '200px', left: '-200px', zIndex: -1 }} />

                <div id="app-summary-inner">
                    <img src="./images/generic/bg-icon-waves.png" alt="" style={{ position: 'absolute', top: '100px', right: '-140px' }} />
                    <img src="./images/app-summary/bg-icon-upper-left.png" alt="" style={{ position: 'absolute', top: '-55px', left: '-75px' }} />
                    <img src="./images/app-summary/bg-icon-upper-right.png" alt="" style={{ position: 'absolute', top: '-90px', left: '50px' }} />
                    <img src="./images/app-summary/phone-with-screen.png" alt="" style={{ position: 'absolute', top: '20px', left: '0' }} />

                    <div id="app-summary-text" style={{
                        backgroundColor: '#fff',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '400px',
                        height: 'calc(297px + 40px)',
                        border: '1px solid #d3d3d3'
                    }}>
                        <p>
                            Once users are happy with their green makeover, they will receive their very own personalised rating.
                            By adding more plants to their space, they’re able to see how air quality and well-being can rise before their very eyes!
                        </p>
                    </div>

                    <img src="./images/app-summary/phone-rating-screen.png" alt="" style={{ position: 'absolute', bottom: '-40px', right: '50px' }} />
                </div>





                <div id="app-summary-inner-small">
                    <img src="./images/generic/bg-icon-waves-smaller.png" alt="" style={{ position: 'absolute', top: '100px', right: '-140px' }} />
                    <img src="./images/app-summary/bg-icon-upper-left-smaller.png" alt="" style={{ position: 'absolute', top: '-35px', left: '-55px' }} />
                    <img src="./images/app-summary/bg-icon-upper-right-smaller.png" alt="" style={{ position: 'absolute', top: '-70px', left: '30px' }} />
                    <img src="./images/app-summary/phone-with-screen-smaller.png" className='screen' alt="" style={{ position: 'absolute', top: '20px', left: '0' }} />

                    <div id="app-summary-text-small" style={{
                        backgroundColor: '#fff',
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        width: '360px',
                        height: 'calc(208px + 40px)',
                        border: '1px solid #d3d3d3'
                    }}>
                        <div>
                            Once users are happy with their green makeover, they will receive their very own personalised rating.
                            By adding more plants to their space, they’re able to see how air quality and well-being can rise before their very eyes!
                        </div>
                    </div>

                    <img src="./images/app-summary/phone-rating-screen-smaller.png" className='screen' alt="" style={{ position: 'absolute', top: '160px', right: '50px' }} />
                </div>




                <div id="app-summary-inner-stack">
                    <img src="./images/generic/bg-icon-waves-smaller.png" alt="" style={{ position: 'absolute', top: '100px', right: '-60px', zIndex: -1 }} />
                    <img src="./images/app-summary/bg-icon-upper-left-smaller.png" alt="" style={{ position: 'absolute', top: '-60px', left: '40px', zIndex: -1 }} />
                    <img src="./images/app-summary/bg-icon-upper-right-smaller.png" alt="" style={{ position: 'absolute', top: '-90px', left: '140px', zIndex: -1 }} />

                    <div><img src="./images/app-summary/phone-with-screen-smaller.png" className='screen' alt="" /></div>

                    <div id="app-summary-text-stack" style={{
                        backgroundColor: '#fff',
                        borderLeft: '1px solid #d3d3d3',
                        borderRight: '1px solid #d3d3d3',
                        marginTop: '-2px',
                        marginBottom: '-2px',
                        padding: '20px',
                        zIndex: 1
                    }}>
                        <div>
                            Once users are happy with their green makeover, they will receive their very own personalised rating.
                            By adding more plants to their space, they’re able to see how air quality and well-being can rise before their very eyes!
                        </div>
                    </div>

                    <div><img src="./images/app-summary/phone-rating-screen-smaller.png" className='screen' alt="" /></div>
                </div>

                <DownArrow />

                {this.props.children}
            </PageSection>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/sections/AppSummary.jsx